<section hlmCard class="create-account-card">
  <div hlmCardContent>
    <div class="create-account-card__content">
      <p class="create-account-card__welcome">{{ 'login-form.welcome-to-ocp' | translate }}</p>
      <h1 class="create-account-card__title">{{ 'create-account-form.title' | translate }}</h1>
      <p class="create-account-card__description">
        {{ 'create-account-form.description' | translate }}
      </p>
    </div>

    <div class="create-account-card__actions">
      <button
        hlmBtn
        variant="outline"
        class="create-account-card__button"
        (click)="allplanId.emit()"
      >
        <ocp-themed-icon name="connect.svg" [size]="18" />
        {{ 'create-account-form.continue-with-allplan-id' | translate }}
      </button>
      <button
        hlmBtn
        variant="outline"
        class="create-account-card__button"
        (click)="graphisoftId.emit()"
      >
        <ocp-themed-icon name="graphisoft-id.svg" [size]="18" />
        {{ 'create-account-form.continue-with-graphisoft-id' | translate }}
      </button>
    </div>

    <p class="create-account-card__footer">
      {{ 'create-account-form.already-have-account' | translate }}
      <button type="button" class="create-account-card__link" (click)="signIn.emit()">
        {{ 'create-account-form.sign-in' | translate }}
      </button>
    </p>
  </div>
</section>
